// extracted by mini-css-extract-plugin
export default {"subtitle":"PeripheralSettings_subtitle__YINMX","toggle_block":"PeripheralSettings_toggle_block__V2E1w","toggle":"PeripheralSettings_toggle__890g1"};